import {
    CORE_GET_RM_TAG_REQUEST,
    CORE_GET_RM_TAG_SUCCESS,
    CORE_GET_RM_TAG_FAILURE,

    CORE_CREATE_RM_TAG_REQUEST,
    CORE_CREATE_RM_TAG_SUCCESS,
    CORE_CREATE_RM_TAG_FAILURE,

    CORE_GET_PD_TAG_REQUEST,
    CORE_GET_PD_TAG_SUCCESS,
    CORE_GET_PD_TAG_FAILURE,

    CORE_CREATE_PD_TAG_REQUEST,
    CORE_CREATE_PD_TAG_SUCCESS,
    CORE_CREATE_PD_TAG_FAILURE,

    REQUEST_STATE
} from '../types'

const requestState = REQUEST_STATE

export default {
    tagDatas: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_RM_TAG_REQUEST:
                return state
            case CORE_GET_RM_TAG_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_RM_TAG_FAILURE:
                return []
            default:
                return state
        }
    },
    tagData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_PD_TAG_REQUEST:
                return state
            case CORE_GET_PD_TAG_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_PD_TAG_FAILURE:
                return {}
            default:
                return state
        }
    },
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/qrtag.js